import "./6f5f39edab7aa63af4b2733fc9b48acc.css";
export default {"container":"_eTIYU"};